import { create } from 'zustand';

import type { StudyMode, StudyModeState } from './use-study-mode.model';

export const useStudyModeStore = create<StudyModeState>((set) => ({
  isAddendumMode: false,
  isReadOnlyMode: false,
  isStudyModeResolving: false,
  resetStudyMode: () =>
    set({
      isAddendumMode: false,
      isReadOnlyMode: false,
      isStudyModeResolving: false,
      studyMode: null,
    }),
  setStudyMode: (mode: null | StudyMode) =>
    set({
      isAddendumMode: mode === 'addendum',
      isReadOnlyMode: mode === 'read-only',
      isStudyModeResolving: false,
      studyMode: mode,
    }),
  setStudyModeResolving: (resolving: boolean) => set({ isStudyModeResolving: resolving }),
  studyMode: null,
}));
